import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project1.png";
import projImg2 from "../assets/img/project2.png";
import projImg3 from "../assets/img/bit.jpeg";
import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const projects = [
    {
      title: "AI Assistant",
      description: "Chat-based Caption Crafting LLM assistant.",
      imgUrl: projImg1,
      demo: "http://cloud-app-env.eba-tu3rjvwq.af-south-1.elasticbeanstalk.com/",
      repo: "https://github.com/MfobesTechJournal",
    },
    {
      title: "Data Pipeline",
      description: "ETL pipeline with S3, Lambda & SQL.",
      imgUrl: projImg2,
      demo: "https://nycsocialservices311-8xytyl5av2bxltnx99mrqh.streamlit.app/",
      repo: "https://github.com/MfobesTechJournal",
    },
    {
      title: "Resume Matcher",
      description: "Chat-based LLM assistant.",
      imgUrl: projImg3,
      demo: "https://bit-trio-resume-job-matcher.vercel.app/",
      repo: "https://github.com/MfobesTechJournal",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    Here are the production-grade applications I’ve deployed.
                    Hover over each project to preview the description and
                    access the live demo or GitHub repo.
                  </p>

                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-4 justify-content-center"
                    >
                      {/* <Nav.Item>
                        <Nav.Link eventKey="first">Projects</Nav.Link>
                      </Nav.Item> */}
                    </Nav>

                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible
                          ? "animate__animated animate__slideInUp"
                          : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => (
                            <ProjectCard key={index} {...project} />
                          ))}
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>

      <img className="background-image-right" src={colorSharp2} alt="" />
    </section>
  );
};
